import { render, staticRenderFns } from "./periodList.vue?vue&type=template&id=36fd7ab5"
import script from "./periodList.vue?vue&type=script&lang=js"
export * from "./periodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports